import { Injectable } from '@angular/core';
import { catchError, Observable, of, take } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { MonthlyPortfolio,MonthlyDetail,ExpiredPortfolio,PortfolioPaidMonthly,DetailExpiredPortfolioAccumulated, DetailPortfolioPaidMonthly, WorkflowQuotes } from '../../models/boards/boards.model';


@Injectable({
  providedIn: 'root',
})
export class BoardsService {
  public URL_API = environment.apiURLNew;

  constructor(
    private http: HttpClient,
  ) {}

  public getMonthlyPortfolio(): Observable<MonthlyPortfolio[] | null> {
    return this.http.get<MonthlyPortfolio[]>(this.URL_API + `/GetMonthlyPortfolio`, {}).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  public getMonthlyDetail(
      idMes: number | string,
    ): Observable<MonthlyDetail[] | null> {
      return this.http
        .get<MonthlyDetail[]>(this.URL_API + `/GetMonthlyDetail/${idMes}`, {})
        .pipe(
          take(1),
          catchError(() => {
            return of(null);
          }),
        );
    }

  public getExpiredPortfolio(): Observable<ExpiredPortfolio[] | null> {
    return this.http.get<ExpiredPortfolio[]>(this.URL_API + `/GetExpiredPortfolio`, {}).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  public getPortfolioPaidMonthly(): Observable<PortfolioPaidMonthly[] | null> {
    return this.http.get<PortfolioPaidMonthly[]>(this.URL_API + `/GetPortfolioPaidMonthly`, {}).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  public getDetailExpiredPortfolioAccumulated(
      idMes: number | string,
    ): Observable<DetailExpiredPortfolioAccumulated[] | null> {
      return this.http
        .get<DetailExpiredPortfolioAccumulated[]>(this.URL_API + `/GetDetailExpiredPortfolioAccumulated/${idMes}`, {})
        .pipe(
          take(1),
          catchError(() => {
            return of(null);
          }),
        );
    }

    public getDetailPortfolioPaidMonthly(
      idMes: number | string,
      tipo: number | string,
    ): Observable<DetailPortfolioPaidMonthly[] | null> {
      return this.http
        .get<DetailPortfolioPaidMonthly[]>(this.URL_API + `/GetDetailPortfolioPaidMonthly/${idMes}/${tipo}`, {})
        .pipe(
          take(1),
          catchError(() => {
            return of(null);
          }),
        );
    }

    public getWorkflowQuotes(): Observable<WorkflowQuotes[] | null> {
    return this.http.get<WorkflowQuotes[]>(this.URL_API + `/GetWorkflowQuotes`, {}).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }
}
